import React from 'react';
import { useTheme } from 'styled-components/macro';
import { NewModal } from 'lib/components';
import { Button } from 'react-covideo-common';
import { ParagraphNormal15 } from 'lib/components/styles/typography';
import { Flex } from 'lib/components/styles/layout';

type Props = {
  handleStopFolderSharing: () => void;
  handleModalClose: () => void;
};

export const StopFolderSharingModal = ({
  handleStopFolderSharing,
  handleModalClose,
}: Props) => {
  const themes = useTheme();
  return (
    <NewModal
      headerText={'Stop Sharing Folder'}
      closeModalOnBackdropOrEscPress={true}
      closeModal={() => handleModalClose()}
      headerMargin='0 0 0 0'
      style={{
        content: {
          padding: '24px 24px 16px 24px',
          minWidth: 'auto',
          paddingLeft: '32px',
          width: '592px',
          maxWidth: '592px',
        },
      }}
    >
      <Flex gap='29px' flexDirection='column'>
        <Flex padding='16px 0 0 0' width='508px'>
          <ParagraphNormal15 color={themes.colors.neutral[80]}>
            Are you sure you want to stop sharing this folder? This will remove
            access for all users currently allowed to view or edit it.
          </ParagraphNormal15>
        </Flex>
        <Flex
          flexDirection='row'
          margin='32px 0 0 0'
          alignItems='center'
          justifyContent='flex-end'
          gap='12px'
        >
          <Button
            onClick={async () => handleModalClose()}
            variant='secondary'
            text='Cancel'
          />
          <Button
            text={'Stop Sharing'}
            variant='red'
            onClick={() => {
              handleStopFolderSharing();
            }}
          />
        </Flex>
      </Flex>
    </NewModal>
  );
};
